module.exports = __webpack_public_path__ + "static/pic_pcTeacher-e95086213a97d459ae7ee3cc8a612734.png";